class BHistory {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const sections = document.querySelectorAll(`.${this.el}`);
    if (!sections.length) return;

    sections.forEach((section) => {
      const wrap = section.querySelector('.b-history-wrap');
      const scrollbar = section.querySelector('.b-history-scrollbar');
      const scrollbarBtn = section.querySelector('.b-history-scrollbarbtn');

      if (!wrap || !scrollbar || !scrollbarBtn) return;

      const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
      const trackInset = 6;
      let isDragging = false;
      let dragOffsetX = 0;

      const getScrollMax = () => Math.max(wrap.scrollWidth - wrap.clientWidth, 0);
      const getTrackRange = () => {
        const min = trackInset;
        const max = Math.max(
          scrollbar.clientWidth - trackInset - scrollbarBtn.offsetWidth,
          min
        );
        return { min, max };
      };

      const syncButtonPositionByScroll = () => {
        const scrollMax = getScrollMax();
        const { min, max } = getTrackRange();
        const trackDistance = max - min;

        if (trackDistance <= 0 || scrollMax <= 0) {
          scrollbarBtn.style.left = `${min}px`;
          return;
        }

        const rate = wrap.scrollLeft / scrollMax;
        scrollbarBtn.style.left = `${min + rate * trackDistance}px`;
      };

      const syncScrollByButtonLeft = (left) => {
        const scrollMax = getScrollMax();
        const { min, max } = getTrackRange();
        const trackDistance = max - min;
        const safeLeft = clamp(left, min, max);

        scrollbarBtn.style.left = `${safeLeft}px`;

        if (trackDistance <= 0 || scrollMax <= 0) {
          wrap.scrollLeft = 0;
          return;
        }

        const rate = (safeLeft - min) / trackDistance;
        wrap.scrollLeft = rate * scrollMax;
      };

      const startDrag = (clientX) => {
        const btnRect = scrollbarBtn.getBoundingClientRect();
        isDragging = true;
        dragOffsetX = clientX - btnRect.left;
        document.body.style.userSelect = 'none';
      };

      const moveDrag = (clientX) => {
        if (!isDragging) return;

        const barRect = scrollbar.getBoundingClientRect();
        const nextLeft = clientX - barRect.left - dragOffsetX;
        syncScrollByButtonLeft(nextLeft);
      };

      const endDrag = () => {
        if (!isDragging) return;
        isDragging = false;
        document.body.style.userSelect = '';
      };

      const getClientX = (e) => {
        if (typeof e.clientX === 'number') return e.clientX;
        if (e.touches && e.touches[0]) return e.touches[0].clientX;
        if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].clientX;
        return null;
      };

      wrap.addEventListener('scroll', syncButtonPositionByScroll, { passive: true });

      scrollbarBtn.addEventListener('mousedown', (e) => {
        e.preventDefault();
        startDrag(e.clientX);
      });

      window.addEventListener('mousemove', (e) => {
        moveDrag(e.clientX);
      });

      window.addEventListener('mouseup', () => {
        endDrag();
      });

      scrollbarBtn.addEventListener('touchstart', (e) => {
        const clientX = getClientX(e);
        if (clientX === null) return;
        e.preventDefault();
        startDrag(clientX);
      }, { passive: false });

      window.addEventListener('touchmove', (e) => {
        const clientX = getClientX(e);
        if (clientX === null) return;
        if (isDragging) e.preventDefault();
        moveDrag(clientX);
      }, { passive: false });

      window.addEventListener('touchend', () => {
        endDrag();
      });

      window.addEventListener('touchcancel', () => {
        endDrag();
      });

      scrollbar.addEventListener('click', (e) => {
        if (e.target === scrollbarBtn || scrollbarBtn.contains(e.target)) return;
        const barRect = scrollbar.getBoundingClientRect();
        const nextLeft = e.clientX - barRect.left - scrollbarBtn.offsetWidth / 2;
        syncScrollByButtonLeft(nextLeft);
      });

      window.addEventListener('resize', syncButtonPositionByScroll);
      syncButtonPositionByScroll();
    });
  }
}
